// import React from "react";
// import "./style.scss";

// export default function Footer() {
//   return (
//     <footer >
//     </footer>
//   );
// }

import React, { useEffect, useState } from "react";
import "../Footer/style.scss";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import { AiOutlinePhone } from "react-icons/ai";
import { MdEmail, MdLocationOn } from "react-icons/md";
import {
  Email,
  EmailCon,
  FaceBook,
  FixedWhatsApp,
  Instagram,
  Linkedin,
  Location,
  MarkLogo,
  Phone,
  TelePhone,
  TextBlockICon,
  UseriCon,
  WhatsappIcon,
  XTwitter,
  Youtube,
} from "../../constants/svgPath";
import { Link, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/material.css";
import { contactUs, whatsappUpdate } from "../../redux/actions/settings";
import { useSelector } from "react-redux";
import { countryToDial } from "../../constants/constant";
import ContactUs from "../Popup/ContactUs";
export default function Footer() {
  const { countryData } = useSelector((state: any) => state.settings);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [countryCode, setCountryCode] = useState<string>("");
  const [countryCodeForWhatsAppUpdate, setCountryCodeForWhatsAppUpdate] =
    useState("");
  const [whatsAppPhone, setWhatsAppPhone] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [defaultCountryCode, setDefaultCountryCode] = useState(
    String(countryData?.country_code).toLocaleLowerCase(),
  );

  React.useEffect(() => {
    // Reset ALL form values & errors on route change
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setErrors({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  }, [location.pathname]);

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const validate = () => {
    const newErrors = { name: "", email: "", phone: "", message: "" };
    let valid = true;

    // Name validation (first letter capital + max length 15)
    if (!name) {
      newErrors.name = "Name is required.";
      valid = false;
    } else if (name.length > 15) {
      newErrors.name = "Name must be 15 characters or less.";
      valid = false;
    }

    // Email validation
    if (!email) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Enter a valid email address.";
      valid = false;
    }

    // Phone validation
    if (!phone) {
      newErrors.phone = "Phone number is required.";
      valid = false;
    } else if (phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Enter a valid phone number.";
      valid = false;
    }

    // Message validation (max 250 chars)
    if (!message) {
      newErrors.message = "Message is required.";
      valid = false;
    } else if (message.length > 250) {
      newErrors.message = "Message cannot exceed 250 characters.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // ----------------------------
  // 🧭 Submit Handler
  // ----------------------------
  const handleSubmit = () => {
    if (validate()) {
      setLoading(true);
      const apiData = {
        name: name,
        email: email,
        phoneNumber: phone.substring(countryCode.length),
        countryCode: `+${countryCode}`,
        description: message,
        deviceInfo: navigator.userAgent,
      };
      contactUs(apiData)
        .then((res: any) => {
          alert(
            "Thank you!! One of Our Experts Will Get in Touch With You Shortly",
          );
        })
        .catch((error) => {
          alert(error?.message);
        })
        .finally(() => {
          setName("");
          setLoading(false);
          setCountryCode("");
          setEmail("");
          setMessage("");
        });
      // 👇 send data to API or backend here
    }
  };

  const handleSubmitForWhatsAppUpdate = () => {
    if (whatsAppPhone && countryCodeForWhatsAppUpdate) {
      setLoading1(true);
      const apiData = {
        phoneNumber: whatsAppPhone.substring(
          countryCodeForWhatsAppUpdate.length,
        ),
        countryCode: `+${countryCodeForWhatsAppUpdate}`,
        deviceInfo: navigator.userAgent,
      };
      whatsappUpdate(apiData)
        .then((res: any) => {
          setWhatsAppPhone("");
          alert(
            "Thank you!! One of Our Experts Will Get in Touch With You Shortly",
          );
        })
        .catch((error) => {
          alert(error?.message);
        })
        .finally(() => {
          setLoading1(false);
          setWhatsAppPhone("");
        });
    }
  };

  useEffect(() => {
    setDefaultCountryCode(
      String(countryData?.country_code).toLocaleLowerCase(),
    );
    setCountryCode(
      countryToDial[countryData?.country_code as keyof typeof countryToDial] ??
        "91",
    );
  }, [countryData]);

  return (
    <>
      <section className="ready_sec">
        <div className="contair ready_inner">
          <div className="ready_mn">
            <div className="ready_l">
              <div className="next_heading">
                <h2>
                  Ready to begin your transformation with cutting-edge
                  technology?
                </h2>
                <p>
                  We help businesses move from where they are to where they need
                  to be by unlocking scalable digital solutions. Let’s connect
                  and build what’s next.
                </p>
              </div>
            </div>
          </div>
          <div className="ready_frm">
            <div className="commn_frm">
              <h3>Let’s Team Up to Take Your Business Forward!</h3>

              <div className="commn_frm_innr">
                {/* Name Input */}
                <div className="inp_grp">
                  <span className="inp_icon">
                    <UseriCon />
                  </span>
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="inp_frm"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={15}
                  />
                  {errors.name && <p className="txt_vaild">{errors.name}</p>}
                </div>

                {/* Email Input */}
                <div className="inp_grp">
                  <span className="inp_icon">
                    <EmailCon />
                  </span>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="inp_frm"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <p className="txt_vaild">{errors.email}</p>}
                </div>

                {/* Phone Input */}
                <div className="inp_grp">
                  <PhoneInput
                    country={defaultCountryCode}
                    value={phone}
                    onChange={(value, country: any) => {
                      setCountryCode(country?.dialCode);
                      setPhone(value);
                    }}
                    dropdownDirection="top"
                  />
                  {errors.phone && <p className="txt_vaild">{errors.phone}</p>}
                </div>

                {/* Message Input */}
                <div className="text_area">
                  <span className="inp_icon">
                    <TextBlockICon />
                  </span>
                  <textarea
                    className="inp_frm"
                    placeholder="Write Message Here..."
                    rows={3}
                    cols={40}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={250}
                  />
                  {errors.message && (
                    <p className="txt_vaild">{errors.message}</p>
                  )}
                </div>

                {/* Submit Button */}
                <div className="inp_grp ">
                  <button
                    disabled={loading}
                    type="button"
                    className="btn_common btn_primry"
                    onClick={handleSubmit}
                  >
                    {loading ? <span className="spinner"></span> : "Send Now"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="flx_icon">
          <a href="tel:+91 73574 94050">
            <TelePhone />
          </a>
          <a
            href="https://wa.me/917357494050"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FixedWhatsApp />
          </a>
        </div>
        <div className="contair ">
          <div className="footer_inrr">
            <div className="footer_logo_mn">
              <Link to="" className="footer_logo">
                <MarkLogo />
              </Link>
              <div className="footer_list">
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  {/* <li>
                    <Link to="">Industries</Link>
                  </li> */}
                  {/* <li>
                    <Link to="">Case-Studies</Link>
                  </li> */}
                  {/* <li>
                    <Link to="">Testimonials</Link>
                  </li> */}
                  <li>
                    <Link to="/">News & Insights</Link>
                  </li>
                  {/* <li>
                    <Link to="">Portfolio</Link>
                  </li> */}
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        setIsPopupOpen(true);
                      }}
                    >
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer_list order_menu_mlb">
                <h3>Services</h3>
                <ul>
                  <li>
                    <Link to={`/services/cross-platform-app-development`}>
                      Cross-Platform App Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/ecommerce-website-development">
                      eCommerce Website Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/shopify-development-services">
                      Shopify Development Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/appointment-app-development">
                      Appointment App Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/home-service-development">
                      Home Service Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/search-engine-optimization-seo">
                      Search Engine Optimization (SEO)
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/cloud-migration-management">
                      Cloud Migration & Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/product-design-prototyping">
                      Product Design & Prototyping
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/project-based-augmentation">
                      Project-Based Augmentation
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/team-expansion">Team Expansion</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer_list order_one">
              <h3>Services</h3>
              <ul>
                <li>
                  <Link to={`/services/cross-platform-app-development`}>
                    Cross-Platform App Development
                  </Link>
                </li>
                <li>
                  <Link to="/services/ecommerce-website-development">
                    eCommerce Website Development
                  </Link>
                </li>
                <li>
                  <Link to="/services/shopify-development-services">
                    Shopify Development Services
                  </Link>
                </li>
                <li>
                  <Link to="/services/appointment-app-development">
                    Appointment App Development
                  </Link>
                </li>
                <li>
                  <Link to="/services/home-service-development">
                    Home Service Development
                  </Link>
                </li>
                <li>
                  <Link to="/services/search-engine-optimization-seo">
                    Search Engine Optimization (SEO)
                  </Link>
                </li>
                <li>
                  <Link to="/services/cloud-migration-management">
                    Cloud Migration & Management
                  </Link>
                </li>
                <li>
                  <Link to="/services/product-design-prototyping">
                    Product Design & Prototyping
                  </Link>
                </li>
                <li>
                  <Link to="/services/project-based-augmentation">
                    Project-Based Augmentation
                  </Link>
                </li>
                <li>
                  <Link to="/services/team-expansion">Team Expansion</Link>
                </li>
              </ul>
            </div>
            <div className="footer_list order_two">
              <h3>Industries</h3>
              <ul>
                <li>
                  <Link to={`/industries/finance`}>Finance/Banking</Link>
                </li>
                <li>
                  <Link to={`/industries/on-demand`}>On-Demand</Link>
                </li>
                <li>
                  <Link to={`/industries/healthcare`}>Healthcare</Link>
                </li>
                <li>
                  <Link to={`/industries/travel&Hospitality`}>
                    Travel & Hospitality
                  </Link>
                </li>
                <li>
                  <Link to={`/industries/realestate`}>Real Estate </Link>
                </li>
                <li>
                  <Link to={`/industries/education`}>Education</Link>
                </li>
                <li>
                  <Link to={`/industries/logistics`}>Logistics</Link>
                </li>
                <li>
                  <Link to={`/industries/media&entertainment`}>
                    Media & Entertainment
                  </Link>
                </li>
                <li>
                  <Link to={`/industries/ecommerce`}>eCommerce</Link>
                </li>
                <li>
                  <Link to={`/industries/government`}>Government</Link>
                </li>
                <li>
                  <Link to={`/industries/automotive`}>
                    Automotive(Auto-Mobile)
                  </Link>
                </li>
                <li>
                  <Link to={"/industries/sports"}>Sports</Link>
                </li>
              </ul>
            </div>
            <div className="footer_list order_thr">
              <h3>Contact Us</h3>
              <ul className="contact-info">
                <li className="flex items-center ">
                  <Link to="tel:+91 73574 94050">
                    <span className="common_border fotr_icon">
                      <Phone />
                    </span>{" "}
                    <span className="fotr_ic_tx">+91 73574 94050</span>
                  </Link>
                </li>
                <li>
                  <Link to="mailto:info@giripstechnologies.com">
                    <span className="common_border fotr_icon">
                      <Email />
                    </span>{" "}
                    <span>
                      info@girips
                      <span className="blk_eml">technologies.com</span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <span className="common_border fotr_icon">
                      <Location />
                    </span>{" "}
                    <span>
                      {" "}
                      A7 Virat Nagar, Goner Road, Jaipur, Rajasthan – 302031,
                      India
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="contair icon_innr">
            <div className="social-icons">
              <h4>Follow Us</h4>
              <div className="footer_icon">
                <a
                  href="https://www.facebook.com/share/1BsMBkVsuP/"
                  className="common_border"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaceBook />
                </a>

                <a
                  href="https://www.instagram.com/giripstechnologies/"
                  className="common_border"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram />
                </a>
                {/* <a
                  href=""
                  className="common_border"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Youtube />
                </a> */}

                <a
                  href="https://www.linkedin.com/company/giripstechnologies"
                  className="common_border"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin />
                </a>
                <a
                  href="https://x.com/giripstech"
                  className="common_border"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <XTwitter />
                </a>
              </div>
            </div>
            <div className="whatsapp-form common_border">
              <h4>
                {" "}
                <WhatsappIcon /> WhatsApp Updates
              </h4>
              <div className="box_whats">
                <PhoneInput
                  country={defaultCountryCode}
                  value={whatsAppPhone}
                  onChange={(value, country: any) => {
                    setCountryCodeForWhatsAppUpdate(country?.dialCode);
                    setWhatsAppPhone(value);
                  }}
                  placeholder="| Phone Number"
                  inputClass="phone-input"
                />
                <button
                  disabled={loading1}
                  type="button"
                  className={`btn_common btn_primry ${loading1 && "btn_min_width"}`}
                  onClick={handleSubmitForWhatsAppUpdate}
                >
                  {loading1 ? <span className="spinner"></span> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="copy_rght">
          <div className="contair copy_flx">
            <p>© Copyright 2025. Girips Technologies. All Rights Reserved.</p>

            <div className="footer-links">
              <Link to="/terms-conditions">Terms & Conditions</Link>
              <Link to="/privacy-policy">Privacy & Policy</Link>
            </div>
          </div>
        </div>
        <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      </footer>
    </>
  );
}
